export const tableLabel = [
  {
    label: '物料分类',
    param: 'categoryName',
    align: 'center',
    minWidth: 180,
    tooltip: true,
  },
  {
    label: '物料编码',
    param: 'categoryCustomCode',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '物料描述',
    param: 'categoryDesc',
    align: 'center',
    minWidth: 180,
    tooltip: true,
  },
  {
    label: '剩余未采数量',
    param: 'remainingQuantity',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '需求计划编号',
    param: 'purchaseDemandCode',
    align: 'center',
    minWidth: 220,
  },
  {
    label: '需求计划名称',
    param: 'purchaseDemandName',
    align: 'center',
    minWidth: 230,
  },
  {
    label: '采购数量',
    param: 'quantity',
    align: 'center',
    minWidth: 160,
  },
  {
    label: '创建日期',
    param: 'createTime',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '需求申请人',
    param: 'createMemberName',
    align: 'center',
    minWidth: 180,
  },
  // 如果操作有图标的话 label 的是一个字符串
  {
    label: 'header',
    align: 'center',
    fixed: 'right',
    slot: 'handle',
    header: true,
    minWidth: 180,
  },
];

export const fieldList = [
  {
    label: '需求计划名称',
    type: 'input',
    value: 'purchaseDemandName',
  },
  {
    label: '需求计划编号',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '创建日期',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
  },
  {
    label: '物料',
    type: 'input',
    value: 'categoryDesc',
  },
];
